<label>
  {{ 'APP.SELECT' | translate }}
  <select #langSelect (change)="translate.use(langSelect.value)">
    <option *ngFor="let lang of translate.getLangs()" [value]="lang" [selected]="lang === translate.currentLang">
      {{ lang }}
    </option>
  </select>
</label>
